import React from "react";
import { Button, Checkbox, Form, Input, InputNumber, Space, Table } from "antd";
import { ApplyDocumentViewItem } from "../Components/ApplyDocumentDrawer";
import {
  ApplicantInfo,
  EvaluationViewpoint,
  EvaluationViewpointDetail,
} from "./ScoringPage";
import { ApplyDocumentView } from "../Components/ApplyDocumentView";
import { EvaluationViewpointSelecter } from "./EvaluationViewpointSelecter";
import { ScoringTableProps } from "./ScoringTable";
import moment from "moment";
import { Messages } from "../Common/ValidateMessages";
import { isEmptyString } from "../Common/Utils";

export const validatorCheckScore = async (
  value: any,
  lowScore: number,
  hightScore: number
): Promise<void> => {
  try {
    if (value === undefined || value == null || value === "")
      return Promise.resolve();

    if (value < lowScore || value > hightScore)
      return Promise.reject(
        new Error(`[${lowScore}-${hightScore}]の数字が入力可能です。`)
      );
  } catch (error) {
    // エラー
    console.log(error);
  }
};

export const setPersonNodes = (
  applicant: ApplicantInfo,
  scoringType: string,
  useCase: string,
  onDocumentLinkClick: (documents?: ApplyDocumentViewItem[]) => void,
  pattern: number,
  showPersonInfoItemFlags: string[]
): any[] => {
  const titleNodes: any[] = [];
  if (scoringType === "2") {
    titleNodes.push(
      <Button
        type="primary"
        onClick={() => onDocumentLinkClick(applicant.commonDocuments)}
        style={{ marginBottom: "2px" }}
      >
        提出書類
      </Button>
    );
    if (applicant.facePictureDocument) {
      titleNodes.push(
        <div style={{ width: "80px", height: "122px" }}>
          <ApplyDocumentView viewDocument={applicant.facePictureDocument!} />
        </div>
      );
    }
    if (showPersonInfoItemFlags[0] === "1") {
      titleNodes.push(
        <span style={{ fontSize: "17px", textAlign: "center" }}>
          {applicant.examNo}
        </span>
      );
    }
    if (showPersonInfoItemFlags[1] === "1") {
      titleNodes.push(
        <span style={{ fontSize: "17px", textAlign: "center" }}>
          {applicant.sei} {applicant.mei}
        </span>
      );
    }
    if (showPersonInfoItemFlags[2] === "1") {
      titleNodes.push(
        <div style={{ fontSize: "17px", textAlign: "center" }}>
          {applicant.seiKana} {applicant.meiKana}
        </div>
      );
    }
    if (showPersonInfoItemFlags[3] === "1") {
      titleNodes.push(
        <span>{moment(applicant.birthday).format("yyyy/MM/DD")}</span>
      );
    }
    if (showPersonInfoItemFlags[4] === "1") {
      titleNodes.push(
        <div style={{ width: "120px", height: "40px", textAlign: "center" }}>
          {applicant.highSchoolName}
        </div>
      );
    }
  }
  // if (pattern !== 4 && pattern !== 7 && pattern !== 8) {
  //   if (useCase === "1") {
  //     titleNodes.push(<span>合計点:99</span>);
  //   } else if (useCase === "2") {
  //     if (applicant.scoringResults && applicant.scoringResults.length > 0) {
  //       applicant.scoringResults.forEach(
  //         (scoringResult, scoringResultIndex) => {
  //           titleNodes.push(
  //             <span>
  //               {scoringResult.sei}
  //               {scoringResult.mei}:{scoringResult.totalScore}
  //             </span>
  //           );
  //         }
  //       );
  //     }
  //     titleNodes.push(<span>確定値:99</span>);
  //   } else if (useCase === "3" || useCase === "4") {
  //     applicant.scoringResults.forEach((scoringResult, scoringResultIndex) => {
  //       titleNodes.push(
  //         <span>
  //           {scoringResult.sei}
  //           {scoringResult.mei}:{scoringResult.totalScore}
  //         </span>
  //       );
  //     });
  //   }
  // }
  return titleNodes;
};
export const onScoreChanged = (
  v: number,
  applicantId: string,
  currentObjectId: string
) => {
  // console.log(v);
  let sumDiv = document.querySelector(`#sum_${applicantId}`);
  let nodeList = document.querySelectorAll<HTMLInputElement>(
    `input[id^=score_${applicantId}_]`
  );
  let sum = 0;
  nodeList.forEach((node) => {
    if (node.id === currentObjectId) {
      sum = sum + v;
    } else {
      sum = sum + Number(node.value);
    }
    // console.log(typeof node);
    // console.log(node.value);
    // console.log(sum);
  });
  sumDiv!.innerHTML = String(sum);
};
export const setSummary = (
  useCase: string,
  applicants: ApplicantInfo[],
  colSpanTitle: number,
  colSpanData: number
) => {
  const summaryNodes: any[] = [];
  const commentNodes: any[] = [];

  if (useCase === "1") {
    applicants.forEach((applicant, applicantIndex) => {
      const comments = [
        applicant.userScoringResult?.comment
          ? applicant.userScoringResult?.comment
          : "",
      ];
      summaryNodes.push(
        <Table.Summary.Cell
          index={colSpanTitle + applicantIndex * colSpanData}
          colSpan={colSpanData}
        >
          <div
            className="total-score-div font-size-20"
            id={`sum_${applicant.applicantId}`}
          >
            {applicant.userScoringResult?.totalScore}
          </div>
        </Table.Summary.Cell>
      );
      commentNodes.push(
        <Table.Summary.Cell
          index={colSpanTitle + applicantIndex * colSpanData}
          colSpan={colSpanData}
        >
          <Form.Item
            label=""
            name={`comment_${applicant.applicantId}`}
            initialValue={comments.join("\n")}
            rules={[
              {
                max: 100,
                type: "string",
                message: Messages["ERR-050"],
              },
            ]}
          >
            <Input.TextArea rows={4} maxLength={100} />
          </Form.Item>
        </Table.Summary.Cell>
      );
    });
  } else if (useCase === "2") {
    applicants.forEach((applicant, applicantIndex) => {
      const scores: any[] = [];
      const comments: string[] = [];
      if (applicant.scoringResults && applicant.scoringResults.length > 0) {
        applicant.scoringResults.forEach(
          (scoringResult, scoringResultIndex) => {
            const comentValue = isEmptyString(scoringResult.comment)
              ? scoringResult.comment
              : "コメントなし";
            comments.push(
              `${scoringResult.sei} ${scoringResult.mei} コメント\n${comentValue}`
            );
            scores.push(
              <div className="total-score-div">
                <Space>
                  <span>
                    {scoringResult.sei}
                    {scoringResult.mei}:
                  </span>
                  <span className="scoreSpanTotal">
                    {scoringResult.totalScore}
                  </span>
                  <Checkbox
                    style={{ color: "#3fb0ac", marginLeft: "5px" }}
                    checked={scoringResult.absenceFlag === "1" ? true : false}
                    disabled={true}
                  >
                    欠席
                  </Checkbox>
                </Space>
              </div>
            );
          }
        );
      }
      scores.push(
        <div className="total-score-confirm-div">
          <Space>
            <span>確定値:</span>
            <span
              id={`sum_${applicant.applicantId}`}
              className="scoreSpanTotal"
            >
              {applicant.userScoringResult?.totalScore}
            </span>
          </Space>
        </div>
      );
      summaryNodes.push(
        <Table.Summary.Cell
          index={colSpanTitle + applicantIndex * colSpanData}
          colSpan={colSpanData}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            {scores}
          </Space>
        </Table.Summary.Cell>
      );
      commentNodes.push(
        <Table.Summary.Cell
          index={colSpanTitle + applicantIndex * colSpanData}
          colSpan={colSpanData}
        >
          {/* <Form.Item
            label=""
            name={`comment_${applicant.applicantId}`}
            initialValue={comments.join("\n")}
          > */}
          <Input.TextArea
            rows={4}
            readOnly={true}
            value={comments.join("\n")}
          />
          {/* </Form.Item> */}
        </Table.Summary.Cell>
      );
    });
  } else if (useCase === "3") {
    applicants.forEach((applicant, applicantIndex) => {
      const scores: any[] = [];
      const comments: string[] = [];
      if (applicant.scoringResults && applicant.scoringResults.length > 0) {
        applicant.scoringResults.forEach(
          (scoringResult, scoringResultIndex) => {
            const comentValue = isEmptyString(scoringResult.comment)
              ? scoringResult.comment
              : "コメントなし";
            comments.push(
              `${scoringResult.sei} ${scoringResult.mei} コメント\n${comentValue}`
            );
            scores.push(
              <div className="total-score-div">
                <Space>
                  <span>
                    {scoringResult.sei}
                    {scoringResult.mei}:
                  </span>
                  <span
                    id={`sum_${applicant.applicantId}_${scoringResult.userId}`}
                    className="scoreSpanTotal"
                  >
                    {scoringResult.totalScore}
                  </span>
                  <Form.Item
                    label=""
                    name={`af_${applicant.applicantId}_${scoringResult.userId}`}
                    initialValue={
                      scoringResult.absenceFlag === "1" ? true : false
                    }
                    valuePropName="checked"
                    style={{ marginLeft: "5px" }}
                  >
                    <Checkbox style={{ color: "#3fb0ac" }}>欠席</Checkbox>
                  </Form.Item>
                </Space>
              </div>
            );
          }
        );
      }
      summaryNodes.push(
        <Table.Summary.Cell
          index={colSpanTitle + applicantIndex * colSpanData}
          colSpan={colSpanData}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            {scores}
          </Space>
        </Table.Summary.Cell>
      );
      commentNodes.push(
        <Table.Summary.Cell
          index={colSpanTitle + applicantIndex * colSpanData}
          colSpan={colSpanData}
        >
          {/* <Form.Item
            label=""
            name={`comment_${applicant.applicantId}`}
            initialValue={comments.join("\n")}
          > */}
          <Input.TextArea
            rows={4}
            readOnly={true}
            value={comments.join("\n")}
          />
          {/* </Form.Item> */}
        </Table.Summary.Cell>
      );
    });
  } else if (useCase === "4") {
    applicants.forEach((applicant, applicantIndex) => {
      const scores: any[] = [];
      const comments: string[] = [];
      if (applicant.scoringResults && applicant.scoringResults.length > 0) {
        applicant.scoringResults.forEach(
          (scoringResult, scoringResultIndex) => {
            const comentValue = isEmptyString(scoringResult.comment)
              ? scoringResult.comment
              : "コメントなし";
            comments.push(
              `${scoringResult.sei} ${scoringResult.mei} コメント\n${comentValue}`
            );
            scores.push(
              <div className="total-score-view-div">
                <Space>
                  <span>
                    {scoringResult.sei}
                    {scoringResult.mei}:
                  </span>
                  <span
                    id={`sum_${applicant.applicantId}_${scoringResult.userId}`}
                    className="scoreSpanTotal"
                  >
                    {scoringResult.totalScore}
                  </span>
                  <Checkbox
                    style={{ color: "#3fb0ac", marginLeft: "5px" }}
                    checked={scoringResult.absenceFlag === "1" ? true : false}
                    disabled={true}
                  >
                    欠席
                  </Checkbox>
                </Space>
              </div>
            );
          }
        );
      }
      scores.push(
        <div className="total-score-confirm-div">
          <Space>
            確定値:
            <span
              id={`sum_${applicant.applicantId}`}
              className="scoreSpanTotal"
            >
              {applicant.userScoringResult?.totalScore}
            </span>
          </Space>
        </div>
      );
      summaryNodes.push(
        <Table.Summary.Cell
          index={colSpanTitle + applicantIndex * colSpanData}
          colSpan={colSpanData}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            {scores}
          </Space>
        </Table.Summary.Cell>
      );
      commentNodes.push(
        <Table.Summary.Cell
          index={colSpanTitle + applicantIndex * colSpanData}
          colSpan={colSpanData}
        >
          <Input.TextArea
            rows={4}
            readOnly={true}
            value={comments.join("\n")}
          />
        </Table.Summary.Cell>
      );
    });
  }

  return (
    <Table.Summary fixed>
      <Table.Summary.Row>
        <Table.Summary.Cell
          index={0}
          colSpan={colSpanTitle}
          className="table-summary-title"
        >
          合計
        </Table.Summary.Cell>
        {summaryNodes}
      </Table.Summary.Row>
      <Table.Summary.Row>
        <Table.Summary.Cell
          index={0}
          colSpan={colSpanTitle}
          className="table-summary-title"
        >
          総括コメント
        </Table.Summary.Cell>
        {commentNodes}
      </Table.Summary.Row>
    </Table.Summary>
  );
};

export const ScoringTable1 = ({
  showPersonInfo,
  showPersonInfoItemFlags,
  useCase,
  scoringType,
  evaluations,
  applicants,
  onDocumentLinkClick,
  setFormFiledValue,
  afMap,
}: ScoringTableProps) => {
  const [columns, setColumns] = React.useState<any[]>([]);
  const [viewPointDetails, setViewPointDetails] = React.useState<any[]>([]);
  const [currentControlName, setCurrentControlName] =
    React.useState<string>("");
  const [viewPointSelecterVisible, setViewPointSelecterVisible] =
    React.useState<boolean>(false);

  const onViewPointDetailSelect = (dataSelect?: EvaluationViewpointDetail) => {
    setFormFiledValue(currentControlName, dataSelect?.highScore);
    setViewPointSelecterVisible(false);
    const splitted = currentControlName.split("_");
    if (useCase === "3") {
      onScoreChanged(
        dataSelect!.highScore,
        `${splitted[1]}_${splitted[2]}`,
        currentControlName
      );
    } else {
      onScoreChanged(dataSelect!.highScore, splitted[1], currentControlName);
    }
  };
  const onViewPointDetailSelecterClose = () => {
    setViewPointSelecterVisible(false);
  };

  React.useEffect(() => {
    const tCloumns: any[] = [];
    tCloumns.push(
      {
        title: <div className="table-title">カテゴリ</div>,
        width: "100px",
        key: `category`,
        dataIndex: "category",
        className: "multip-line-column",
        fixed: "left",
      },
      {
        title: <div className="table-title">サブカテゴリ</div>,
        width: "150px",
        key: `subCategory`,
        dataIndex: "subCategory",
        className: "multip-line-column",
        fixed: "left",
      },
      {
        title: <div className="table-title">問いたい力</div>,
        width: "230px",
        key: `wantToAskPower`,
        dataIndex: "wantToAskPower",
        className: "multip-line-column",
        fixed: "left",
      }
    );
    if (applicants) {
      applicants.forEach((applicant, applicantIndex) => {
        const childrenCloumns: any[] = [
          {
            title: <div className="table-title">評価点</div>,
            width: "230px",
            className: "table-score-cell",
            key: `applicant_${applicantIndex}`,
            render: (value: any, item: EvaluationViewpoint, index: number) => {
              const initValue =
                applicant.userScoringResult?.resultDetails &&
                applicant.userScoringResult?.resultDetails != null
                  ? applicant.userScoringResult?.resultDetails.find(
                      (resultDetailElement) =>
                        resultDetailElement &&
                        resultDetailElement != null &&
                        resultDetailElement.evaluationViewpoint ===
                          item.evaluationViewpointId
                    )
                  : null;
              if (useCase === "1") {
                const controlName = `score_${applicant.applicantId}_${item.evaluationViewpointId}`;
                const afFlag = afMap.get(applicant.applicantId);
                return (
                  <Space size={1}>
                    <Form.Item
                      label=""
                      name={controlName}
                      initialValue={initValue?.score}
                      rules={
                        afFlag
                          ? []
                          : [
                              {
                                required: true,
                                message: Messages["ERR-051"],
                              },
                            ]
                      }
                    >
                      <InputNumber
                        disabled={afFlag}
                        style={{ width: "50px", fontSize: "17px" }}
                        keyboard={true}
                        readOnly={true}
                        onClick={() => {
                          setCurrentControlName(controlName);
                          setViewPointDetails(
                            item.evaluationViewpointDetailList
                          );
                          setViewPointSelecterVisible(true);
                        }}
                        // onChange={(v: number) =>
                        //   onScoreChanged(v, applicant.applicantId, controlName)
                        // }
                      />
                    </Form.Item>
                    <Button
                      disabled={afFlag}
                      type="link"
                      onClick={() => {
                        setCurrentControlName(controlName);
                        setViewPointDetails(item.evaluationViewpointDetailList);
                        setViewPointSelecterVisible(true);
                      }}
                    >
                      選択
                    </Button>
                  </Space>
                );
              } else if (useCase === "2") {
                const resultSpans: any[] = [];
                const controlName = `score_${applicant.applicantId}_${item.evaluationViewpointId}`;
                if (
                  applicant.scoringResults &&
                  applicant.scoringResults.length > 0
                ) {
                  applicant.scoringResults.forEach(
                    (scoringResult, scoringResultIndex) => {
                      const resultDetail = scoringResult.resultDetails.find(
                        (resultDetailElement) =>
                          resultDetailElement.evaluationViewpoint ===
                          item.evaluationViewpointId
                      );
                      resultSpans.push(
                        <span>
                          {scoringResult.sei}
                          {scoringResult.mei}:
                          <span className="scoreSpan">
                            {resultDetail?.score}
                          </span>
                        </span>
                      );
                    }
                  );
                }
                return (
                  <Space direction="vertical">
                    {resultSpans}
                    <Space>
                      <Form.Item
                        label=""
                        name={controlName}
                        initialValue={initValue?.score}
                        rules={[
                          {
                            required: true,
                            message: Messages["ERR-051"],
                          },
                        ]}
                      >
                        <InputNumber
                          style={{ width: "50px", fontSize: "17px" }}
                          keyboard={true}
                          readOnly={true}
                          onClick={() => {
                            setCurrentControlName(controlName);
                            setViewPointDetails(
                              item.evaluationViewpointDetailList
                            );
                            setViewPointSelecterVisible(true);
                          }}
                        />
                      </Form.Item>
                      <Button
                        type="link"
                        onClick={() => {
                          setCurrentControlName(controlName);
                          setViewPointDetails(
                            item.evaluationViewpointDetailList
                          );
                          setViewPointSelecterVisible(true);
                        }}
                      >
                        選択
                      </Button>
                    </Space>
                  </Space>
                );
              } else if (useCase === "3") {
                const resultInputs: any[] = [];
                applicant.scoringResults.forEach(
                  (scoringResult, scoringResultIndex) => {
                    const resultDetail = scoringResult.resultDetails.find(
                      (resultDetailElement) =>
                        resultDetailElement.evaluationViewpoint ===
                        item.evaluationViewpointId
                    );
                    const controlName = `score_${applicant.applicantId}_${scoringResult.userId}_${item.evaluationViewpointId}`;
                    resultInputs.push(
                      <Space>
                        <Form.Item
                          label={`${scoringResult.sei}${scoringResult.mei}`}
                          name={controlName}
                          initialValue={resultDetail?.score}
                          rules={[
                            {
                              required: true,
                              message: Messages["ERR-051"],
                            },
                          ]}
                        >
                          <InputNumber
                            style={{ width: "50px", fontSize: "17px" }}
                            keyboard={true}
                            readOnly={true}
                            onClick={() => {
                              setCurrentControlName(controlName);
                              setViewPointDetails(
                                item.evaluationViewpointDetailList
                              );
                              setViewPointSelecterVisible(true);
                            }}
                          />
                        </Form.Item>
                        <Button
                          type="link"
                          onClick={() => {
                            setCurrentControlName(controlName);
                            setViewPointDetails(
                              item.evaluationViewpointDetailList
                            );
                            setViewPointSelecterVisible(true);
                          }}
                        >
                          選択
                        </Button>
                      </Space>
                    );
                  }
                );
                return <Space direction="vertical">{resultInputs}</Space>;
              } else if (useCase === "4") {
                const resultLabels: any[] = [];
                applicant.scoringResults.forEach(
                  (scoringResult, scoringResultIndex) => {
                    const resultDetail = scoringResult.resultDetails.find(
                      (resultDetailElement) =>
                        resultDetailElement.evaluationViewpoint ===
                        item.evaluationViewpointId
                    );
                    resultLabels.push(
                      <span>
                        {scoringResult.sei}
                        {scoringResult.mei}:
                        <span className="scoreSpan">{resultDetail?.score}</span>
                      </span>
                    );
                  }
                );
                resultLabels.push(
                  <span className="confirmSpan">
                    確定値:
                    <span className="scoreSpan">{initValue?.score}</span>
                  </span>
                );
                return <Space direction="vertical">{resultLabels}</Space>;
              }
              return "";
            },
          },
        ];

        // var titleNodes: any[] = [];
        // var controlName: string = "";
        // var initValue: any = undefined;
        if (scoringType === "2" && showPersonInfo) {
          const titleNodes = setPersonNodes(
            applicant,
            scoringType,
            useCase,
            onDocumentLinkClick,
            1,
            showPersonInfoItemFlags
          );
          tCloumns.push({
            title: (
              <Space
                direction="vertical"
                align="center"
                size={0}
                style={{ width: "100%" }}
              >
                {titleNodes}
              </Space>
            ),
            key: `applicant_${applicantIndex}`,
            children: childrenCloumns,
          });
        } else {
          tCloumns.push(...childrenCloumns);
        }
        // tCloumns.push();
      });
    }

    setColumns(tCloumns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [evaluations, showPersonInfo, afMap]);

  // const comments: string[] = [];
  // if (useCase === "1") {
  //   comments.push(
  //     applicants[0].userScoringResult?.comment
  //       ? applicants[0].userScoringResult?.comment
  //       : ""
  //   );
  // } else {
  //   applicants[0].scoringResults.forEach(
  //     (scoringResult, scoringResultIndex) => {
  //       comments.push(
  //         `${scoringResult.sei} ${scoringResult.mei} コメント\n${scoringResult.comment}`
  //       );
  //     }
  //   );
  // }

  return (
    <div style={{ width: "100%", textAlign: "center" }}>
      <Space direction="vertical">
        <Table
          bordered
          rowKey={(record: any) => record.evaluationViewpointId}
          showSorterTooltip={false}
          columns={columns}
          dataSource={evaluations}
          // onChange={this.onChange}
          pagination={false}
          summary={(_) => setSummary(useCase, applicants, 3, 1)}
          scroll={{
            x:
              useCase !== "1" && applicants.length > 1
                ? 300 * applicants.length
                : true,
          }}
        />
        {/* <div style={{ width: "100%", textAlign: "left" }}>
          <h4>コメント</h4>
          <Form.Item
            label=""
            name={`comment_${applicants[0].applicantId}`}
            initialValue={comments.join("\n")}
          >
            <Input.TextArea rows={4} />
          </Form.Item>
        </div> */}
      </Space>
      <EvaluationViewpointSelecter
        visible={viewPointSelecterVisible}
        viewPoints={viewPointDetails}
        onDataSelect={onViewPointDetailSelect}
        onCancel={onViewPointDetailSelecterClose}
      />
    </div>
  );
};
